import { simpleSet } from '@r/reducers/utils';

const setCalculationModeProjectPercentageLossValue = simpleSet as
  redux.reducers.calculationMode.settings.information.percentageLoss.value;

export const value = setCalculationModeProjectPercentageLossValue(
  'SET_CALCULATION_MODE_PROJECT_PERCENTAGE_LOSS_VALUE',
  { label: '', value: 0 }
);
